import React from 'react';

import COLORS from '../../../constants/colors.constants';

const BrandCaretUpDownIcon = ({
  className = '',
  width = 16,
  height = 16,
  fill = COLORS.brand,
}) => (
  <svg className={className} width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path d="M3.43164 6.63763C3.22165 6.84762 3.37037 7.20667 3.66734 7.20667H12.0797C12.3767 7.20667 12.5254 6.84762 12.3154 6.63763L8.10923 2.43144C7.97905 2.30127 7.768 2.30127 7.63782 2.43144L3.43164 6.63763Z" fill={fill}/>
    <path d="M12.3154 9.36237C12.5254 9.15238 12.3767 8.79333 12.0797 8.79333L3.66734 8.79333C3.37038 8.79333 3.22165 9.15238 3.43164 9.36237L7.63783 13.5686C7.768 13.6987 7.97906 13.6987 8.10923 13.5686L12.3154 9.36237Z" fill={fill}/>
  </svg>
)

export default BrandCaretUpDownIcon;
